import * as TYPES from './constants';
import {
  industrySectorError,
  requestIndustrySector,
  receiveIndustrySector,
} from './actions';

import {API} from 'config/businesspartner.config';
import {Services} from 'core';

const initialState = {
  data: null,
  request: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_INDUSTRY_SECTOR:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_INDUSTRY_SECTOR:
      return {
        ...state,
        data: action.payload,
        request: false,
        error: false,
      };
    case TYPES.INDUSTRY_SECTOR_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchIndustrySector = () => (dispatch, getState) => {
  const services = new Services();
  const {
    auth: {access: {token = null} = {}},
  } = getState();
  dispatch(requestIndustrySector());
  // Employer Company Settings / Talent Ready: always global IndustrySectorNew
  // (Phase 2.9). Do not send pack type — get_content_pack is null for employers.
  let endpoint = `${API.administration.industry}?type=new16`;
  try {
    return services
      .fetchRecords(endpoint, token)
      .then(res => {
        dispatch(receiveIndustrySector(res));
      })
      .catch(err => console.log(err));
  } catch (err) {
    console.log(err);
    dispatch(industrySectorError(err));
  }
};
